module.exports = __webpack_public_path__ + "components/weather-icon/static/daylightsnow@2-8c771223476d80aac90562e25a5ade28.png";